var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('page-nav-bar',{on:{"navBarClick":_vm.navBarClick}}),_vm._v(" "),_c('page-main',{attrs:{"item":_vm.mainItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }